import { Translation } from '@ngneat/transloco';

import { klona } from 'klona/json';

import { ColumnDefaults, Columns, Grid, GridOptions } from '#types/grid';

import { getAvailableColumns } from './get-available-columns';
import { getSelectedColumns } from './get-selected-columns';
import { getSorts } from './get-sorts';
import { setColumnDefaults } from './set-column-defaults';
import { translateColumnHeaders } from './translate-column-headers';

export function initialize<T = any>(
  columns: Columns,
  translations: Translation,
  columnDefaults: ColumnDefaults = {},
  gridOptions: GridOptions = {},
  reset: boolean = false
): Grid<T> {
  const options: GridOptions = {};

  options.filters = gridOptions.filters ?? {};
  options.first = gridOptions.first ?? 0;
  options.page = gridOptions.page ?? 1;
  options.rows = gridOptions.rows ?? 50;

  columns = translateColumnHeaders(columns, translations);
  columns = setColumnDefaults(columns, columnDefaults);

  options.sorts = gridOptions.sorts ?? getSorts(columns);

  const availableColumns = klona(getAvailableColumns([...columns]));
  const selectedColumns = klona(getSelectedColumns([...columns]));

  const defaultAvailableColumns = klona(availableColumns);
  const defaultFilters = klona(options.filters);
  const defaultSelectedColumns = klona(selectedColumns);
  const defaultSorts = klona(options.sorts);

  const state: Grid<T> = {
    availableColumns,
    data: [],
    defaultAvailableColumns,
    defaultFilters,
    defaultSelectedColumns,
    defaultSorts,
    filters: options.filters,
    first: options.first,
    initialized: false,
    page: options.page,
    rows: options.rows,
    saveId: 'default',
    selectedColumns,
    selectedRow: null,
    selectedRows: null,
    sorts: options.sorts,
    summaryRow: null,
    summaryRowText: null,
    totalRows: 0,
  };

  if (reset) {
    state.initialized = true;
  }

  return {
    ...state,
  };
}
